import axios from "../../http/axios/index.js";
import axiosLogin from "../../http/axios/axiosLogin.js";
import { buildQueryFromParams } from "../../utility/util.js";

const API = "/api";
const API_V1 = "/api/v1";
const API_V2 = "/api/v2";

const config = {
  // For API
  hangfire: `${API}/hangfire`,
  Login_service: `${API}/Login`,

  // For API V1
  systemconfig_v1: `${API_V1}/SystemConfig`,
  hangfire_v1: `${API_V1}/hangfire`,
  SystemSetting_v1: `${API_V1}/SystemSetting`,
  lookupdata_v1: `${API_V1}/lookupdata`,
  GlobalMasterlines_v1: `${API_V1}/GlobalMasterlines`,
  Persons_v1: `${API_V1}/Persons`,
  Performance_v1: `${API_V1}/Performance`,
  PerformancePotential_v1: `${API_V1}/PerformancePotential`,
  Reporting_v1: `${API_V1}/Reporting`,
  SuccessionPlan_v1: `${API_V1}/SuccessionPlan`,
  TalentPool_v1: `${API_V1}/TalentPool`,
  UserDatapolicy_v1: `${API_V1}/UserDatapolicy`,
  Rating_v1: `${API_V1}/Rating`,
  payroll_v1: `${API_V1}/payroll`,
  PendingTransfer_v1: `${API_V1}/PendingTransfer`,
  companyInfo_v1: `${API_V1}/CompanyInfo`,
  Dashboard_v1: `${API_V1}/Dashboard`,
  HcmReport_v1: `${API_V1}/HcmReport`,
  organization_v1: `${API_V1}/Organization`,
  worker_v1: `${API_V1}/worker`,
  idp_v1: `${API_V1}/IDP`,
  PerformanceBoxAnalysis_v1: `${API_V1}/PerformanceBoxAnalysis`,
  Workflow_v1: `${API_V1}/Workflow`,
  Competency_v1: `${API_V1}/competencies`,
  Position_v1: `${API_V1}/Position`,
  job_v1: `${API_V1}/job`,
  LearningHcmCourse_v1: `${API_V1}/LearningHcmCourse`,
  Education_v1: `${API_V1}/Education`,
  Sysemail_v1: `${API_V1}/Sysemail`,
  overtime_v1: `${API_V1}/overtime`,
  ReasonCode_v1: `${API_V1}/ReasonCode`,
  KankeiReport_v1: `${API_V1}/KankeiReport`,
  benefit_v1: `${API_V1}/benefit`,
  TimeManagement_v1: `${API_V1}/TimeManagement`,
  policy_v1: `${API_V1}/policy`,
  User_v1: `${API_V1}/User`,
  CompensationLevel_v1: `${API_V1}/CompensationLevel`,
  NumberSequence_v1: `${API_V1}/NumberSequence`,
  WorkerAction_v1: `${API_V1}/WorkerAction`,
  WorkerBPJSTaxInfo_v1: `${API_V1}/WorkerBPJSTaxInfo`,
  Timesheet_v1: `${API_V1}/Timesheet`,
  PersonnelActionType_v1: `${API_V1}/PersonnelActionType`,
  WorkList_v1: `${API_V1}/WorkList`,
  Bank_v1: `${API_V1}/Bank`,
  Applicant_v1: `${API_V1}/Applicant`,
  RecruitmentSetup_v1: `${API_V1}/RecruitmentSetup`,
  WorkerRequest_v1: `${API_V1}/WorkerRequest`,
  ManPowerPlanning_v1: `${API_V1}/ManPowerPlanning`,
  DataChanges_v1: `${API_V1}/DataChanges`,
  Questionnaire_v1: `${API_V1}/Questionnaire`,
  LearningMaster_v1: `${API_V1}/LearningMaster`,
  Document_v1: `${API_V1}/Document`,
  Loan_v1: `${API_V1}/Loan`,
  AlertModel_v1: `${API_V1}/AlertModel`,
  Notification_v1: `${API_V1}/Notification`,
  GlobalMasterTable_v1: `${API_V1}/GlobalMasterTable`,
  Attendance_v1: `${API_V1}/Attendance`,
  TrvExp_v1: `${API_V1}/TrvExp`,
  PayrollReportConfig_v1: `${API_V1}/PayrollReportConfig`,
  TemplateGenerator_v1: `${API_V1}/TemplateGenerator`,
  BlastEmail_v1: `${API_V1}/BlastEmail`,
  leave_v1: `${API_V1}/Leave`,
  Preference_v1: `${API_V1}/Preference`,

  // For API V2
  persons_v2: `${API_V2}/persons`,
  payroll_v2: `${API_V2}/payroll`,
  Attendance_v2: `${API_V2}/Attendance`,
};

const personConfig = {
  async getAllPersonBasicInfo(params) {
    return axios.get(`${config.persons_v2}/getAllPersonBasicInfo`, { params });
  },

  async getV1PersonBasicInfo(payload) {
    return axios.post(`${config.Persons_v1}/getPersonBasicInfo`, payload);
  },

  async getPersonBasicInfo(payload) {
    return axios.post(`${config.persons_v2}/getPersonBasicInfo`, payload);
  },

  async insertUpdatePersonBasicInfo(params, payload) {
    return axios.post(`${config.persons_v2}/InsertUpdatePersonBasicInfo`, { params }, payload);
  },

  async updatePersonImageInfo(payload) {
    return axios.post(`${config.persons_v2}/UpdatePersonImageInfo`, payload);
  },

  async getPersonMaritalInfo(payload) {
    return axios.post(`${config.persons_v2}/getPersonMaritalInfo`, payload);
  },

  async getCurrentPersonMaritalInfo(payload) {
    return axios.post(`${config.persons_v2}/getCurrentPersonMaritalInfo`, payload);
  },

  async insertPersonMaritalInfo(payload) {
    return axios.post(`${config.persons_v2}/insertPersonMaritalInfo`, payload);
  },

  async updatePersonMaritalInfo(payload) {
    return axios.put(`${config.persons_v2}/updatePersonMaritalInfo`, payload);
  },

  async deletePersonMaritalInfo(params) {
    return axios.delete(`${config.persons_v2}/deletePersonMaritalInfo`, { params });
  },

  async getDetailPersonAddress(params) {
    return axios.get(`${config.persons_v2}/getDetailPersonAddress`, null, { params });
  },

  async getPersonAddress(payload) {
    return axios.post(`${config.persons_v2}/getPersonAddress`, payload);
  },

  async insertUpdatePersonAddress(payload) {
    return axios.post(`${config.persons_v2}/InsertUpdatePersonAddress`, payload);
  },

  async deletePersonAddress(params) {
    return axios.delete(`${config.persons_v2}/DeletePersonAddress`, { params });
  },

  async getDetailPersonCommunication(params) {
    return axios.get(`${config.persons_v2}/getDetailPersonCommunication`, { params });
  },

  async getPersonCommunication(payload) {
    return axios.post(`${config.persons_v2}/getPersonCommunication`, payload);
  },

  async insertUpdatePersonCommunication(payload) {
    return axios.post(`${config.persons_v2}/InsertUpdatePersonCommunication`, payload);
  },

  async deletePersonCommunication(params) {
    return axios.delete(`${config.persons_v2}/DeletePersonCommunication`, { params });
  },

  async getDetailPersonIdentification(params) {
    return axios.get(`${config.persons_v2}/getDetailPersonIdentification`, { params });
  },

  async getPersonIdentificationById(payload) {
    return axios.post(`${config.persons_v2}/GetPersonIdentificationById`, payload);
  },

  async insertUpdatePersonIdentification(payload) {
    return axios.post(`${config.persons_v2}/InsertUpdatePersonIdentification`, payload);
  },

  async deletePersonIdentification(params) {
    return axios.delete(`${config.persons_v2}/DeletePersonIdentification`, { params });
  },

  async getDetailPersonFamily(params) {
    return axios.get(`${config.persons_v2}/getDetailPersonFamily`, { params });
  },

  async getPersonFamilyById(payload) {
    return axios.post(`${config.persons_v2}/GetPersonFamilyById`, payload);
  },

  async insertUpdatePersonFamilyInfo(params, payload) {
    return axios.post(`${config.persons_v2}/InsertUpdatePersonFamilyInfo`, { params }, payload);
  },

  async deletePersonFamily(params) {
    return axios.delete(`${config.persons_v2}/DeletePersonFamily`, { params });
  },

  async getDetailPersonEducationById(params) {
    return axios.get(`${config.persons_v2}/getDetailPersonEducationById`, { params });
  },

  async getPersonEducationById(payload) {
    return axios.post(`${config.persons_v2}/GetPersonEducationById`, payload);
  },

  async deletePersonEducationByRecid(params) {
    return axios.delete(`${config.persons_v2}/DeletePersonEducationByRecid`, { params });
  },

  async deletePersonEducation(params) {
    return axios.delete(`${config.persons_v2}/DeletePersonEducation`, { params });
  },

  async getDetailPersonBankAccountById(params) {
    return axios.get(`${config.persons_v2}/GetDetailPersonBankAccountById`, { params });
  },

  async getPersonBankAccountByIdAsync(params) {
    return axios.post(`${config.persons_v2}/GetPersonBankAccountByIdAsync`, null, { params });
  },

  async insertUpdateBankAccount(params, payload) {
    return axios.post(`${config.persons_v2}/InsertUpdateBankAccount`, { params }, payload);
  },

  async deleteBankAccount(params) {
    return axios.delete(`${config.persons_v2}/DeleteBankAccount`, { params });
  },

  async getPersonCertificateByPersonId(params) {
    return axios.get(`${config.persons_v2}/GetPersonCertificateByPersonId`, { params });
  },

  async insertUpdatePersonCertificate(params) {
    return axios.post(`${config.persons_v2}/InsertUpdatePersonCertificate`, null, { params });
  },

  async getPersonCertificateByRecId(params) {
    return axios.post(`${config.persons_v2}/GetPersonCertificateByRecId`, null, { params });
  },

  async deletePersonCertificate(params) {
    return axios.delete(`${config.persons_v2}/DeletePersonCertificate`, { params });
  },

  async getProfesionalExperienceByPersonId(params) {
    return axios.get(`${config.persons_v2}/GetProfesionalExperienceByPersonId`, { params });
  },

  async getProfesionalExperienceByRecId(params) {
    return axios.post(`${config.persons_v2}/GetProfesionalExperienceByRecId`, null, { params });
  },

  async insertUpdateProfesionalExperience(payload) {
    return axios.post(`${config.persons_v2}/InsertUpdateProfesionalExperience`, payload);
  },

  async deleteProfesionalExperience(params) {
    return axios.delete(`${config.persons_v2}/DeleteProfesionalExperience`, { params });
  },

  async getPersonSkillByPersonId(params) {
    return axios.get(`${config.persons_v2}/GetPersonSkillByPersonId`, { params });
  },

  async getPersonSkillByRecId(params) {
    return axios.post(`${config.persons_v2}/GetPersonSkillByRecId`, null, { params });
  },

  async insertUpdatePersonSkill(payload) {
    return axios.post(`${config.persons_v2}/InsertUpdatePersonSkill`, payload);
  },

  async deletePersonSkill(params, payload) {
    return axios.delete(`${config.persons_v2}/DeletePersonSkill`, { params }, payload);
  },

  async getAllPersonaward(params) {
    return axios.get(`${config.persons_v2}/getAllPersonaward`, { params });
  },

  async getAllPersonawardbyrowid(params) {
    return axios.get(`${config.persons_v2}/getAllPersonawardbyrowid`, { params });
  },

  async deletepersonaward(params) {
    return axios.delete(`${config.persons_v2}/deletepersonaward`, { params });
  },

  async insertupdatepersonaward(payload) {
    return axios.post(`${config.persons_v2}/insertupdatepersonaward`, payload);
  },
};

const apisystemconfig = {
  async getbatchjob() {
    return axios.get(`${config.systemconfig_v1}/getbatchjob`);
  },

  async insertupdateBatchJob(payload) {
    return axios.post(`${config.systemconfig_v1}/insertupdateBatchJob`, payload);
  },
};

const SystemSettingConfig = {
  async GetAllBatchHistorybname(params) {
    return axios.get(`${config.SystemSetting_v1}/GetAllBatchHistorybname`, { params });
  },

  async GetAllBatchHistorybrowid(params) {
    return axios.get(`${config.SystemSetting_v1}/GetAllBatchHistorybrowid`, { params });
  },

  async Getsystemsetting() {
    return axios.get(`${config.SystemSetting_v1}/Getsystemsetting`);
  },

  async AddAttachment(payload) {
    return axios.post(`${config.SystemSetting_v1}/AddAttachment`, payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async DeleteAttachment(payload) {
    return axios.post(`${config.SystemSetting_v1}/DeleteAttachment`, payload);
  },

  async GetFormFieldConfig() {
    return axios.get(`${config.SystemSetting_v1}/GetFormFieldConfig`);
  },

  async GetDocumentConfig() {
    return axios.get(`${config.SystemSetting_v1}/GetDocumentConfig`);
  },

  async InsertUpdateDeleteDocumentConfig(payload) {
    return axios.post(`${config.SystemSetting_v1}/InsertUpdateDeleteDocumentConfig`, payload);
  },

  async UpdateFormFieldConfig(payload) {
    return axios.post(`${config.SystemSetting_v1}/UpdateFormFieldConfig`, payload);
  },
};

const hangfireConfig = {
  async activatebatchjob(params) {
    return axios.post(`${config.hangfire}/activatebatchjob`, null, { params });
  },

  async enquebatchjob(params) {
    return axios.post(`${config.hangfire}/enquebatchjob`, null, { params });
  },

  async generateDayPaymentBalance(payload) {
    return axios.post(`${config.hangfire}/generateDayPaymentBalance`, payload);
  },
};

const lookupdataConfig = {
  async getEnum(params) {
    return axios.get(`${config.lookupdata_v1}/getEnum`, { params });
  },

  async getActiveWorkersLookup() {
    return axios.get(`${config.lookupdata_v1}/getActiveWorkersLookup`);
  },

  async getWorkerDetailsByPersonId(params) {
    return axios.get(`${config.lookupdata_v1}/getWorkerDetailsByPersonId`, { params });
  },

  async getWorkerDetailsById(params) {
    return axios.get(`${config.lookupdata_v1}/getWorkerDetailsById`, { params });
  },

  async GetTerminateExpiredWorkerAsync() {
    return axios.get(`${config.lookupdata_v1}/GetTerminateExpiredWorkerAsync`);
  },

  async GetWorkerDetailsAsofDateByWorker(params) {
    return axios.get(`${config.lookupdata_v1}/GetWorkerDetailsAsofDateByWorker`, { params });
  },

  async GetPendingWorkerAsync() {
    return axios.get(`${config.lookupdata_v1}/GetPendingWorkerAsync`);
  },

  async getAllBPJSKesehatan() {
    return axios.get(`${config.lookupdata_v1}/getAllBPJSKesehatan`);
  },

  async getAllBPJSTk() {
    return axios.get(`${config.lookupdata_v1}/getAllBPJSTk`);
  },

  async getLastWorkerDetails(params) {
    return axios.get(`${config.lookupdata_v1}/getLastWorkerDetails`, { params });
  },

  async getWorkersListByFilter(params) {
    return axios.get(`${config.lookupdata_v1}/getWorkersListByFilter`, { params });
  },
};

const GlobalMasterlinesConfig = {
  async findrefid(params) {
    return axios.get(`${config.GlobalMasterlines_v1}/findrefid`, { params });
  },

  async getfindimbysubcompanycode(params) {
    return axios.get(`${config.GlobalMasterlines_v1}/getfindimbysubcompanycode`, { params });
  },
};

const PersonsConfig = {
  async InsertUpdatePersonBasicInfo(payload) {
    return axios.post(`${config.Persons_v1}/InsertUpdatePersonBasicInfo`, payload);
  },

  async GetPersonFamilyById(payload) {
    return axios.post(`${config.Persons_v1}/GetPersonFamilyById`, payload);
  },

  async InsertUpdatePersonFamilyInfo(payload, params) {
    return axios.post(`${config.Persons_v1}/InsertUpdatePersonFamilyInfo`, payload, { params });
  },

  async DeletePersonFamily(params) {
    return axios.delete(`${config.Persons_v1}/DeletePersonFamily`, { params });
  },
};

const performanceConfig = {
  async GetPeriodCycleReviewTemplateByPeriodCycle(params) {
    return axios.get(`${config.Performance_v1}/GetPeriodCycleReviewTemplateByPeriodCycle`, {
      params,
    });
  },

  async InsertUpdatePeriodCycleReviewTemplate(payload) {
    return axios.post(`${config.Performance_v1}/InsertUpdatePeriodCycleReviewTemplate`, payload);
  },

  async DeletePeriodCycleReviewTemplate(params) {
    return axios.delete(`${config.Performance_v1}/DeletePeriodCycleReviewTemplate`, { params });
  },

  async GetPerformanceObjectiveHeaderByCode(params) {
    return axios.get(`${config.Performance_v1}/GetPerformanceObjectiveHeaderByCode`, { params });
  },

  async InsertUpdatePerformanceObjectiveMeasurement(payload) {
    return axios.post(
      `${config.Performance_v1}/InsertUpdatePerformanceObjectiveMeasurement`,
      payload
    );
  },

  async GetAllGoals() {
    return axios.get(`${config.Performance_v1}/GetAllGoals`);
  },

  async GetPerformanceObjectiveMeasurementByObjectiveHeaderCode(params) {
    return axios.get(
      `${config.Performance_v1}/GetPerformanceObjectiveMeasurementByObjectiveHeaderCode`,
      { params }
    );
  },

  async GetPerformanceParameter() {
    return axios.get(`${config.Performance_v1}/GetPerformanceParameter`);
  },

  async GetMeasurementFromLatestWorkerPerformance() {
    return axios.get(`${config.Performance_v1}/GetMeasurementFromLatestWorkerPerformance`);
  },

  async GetPerformancePeriodCycleByCode(params) {
    return axios.get(`${config.Performance_v1}/GetPerformancePeriodCycleByCode`, { params });
  },

  async GetAllRatingConversion() {
    return axios.get(`${config.Performance_v1}/GetAllRatingConversion`);
  },

  async GetAllPerformancePeriodCycle(params) {
    return axios.get(`${config.Performance_v1}/GetAllPerformancePeriodCycle`, { params });
  },

  async GetPeriodCycleAccumulationPercent(params) {
    return axios.get(`${config.Performance_v1}/GetPeriodCycleAccumulationPercent`, { params });
  },

  async InsertUpdatePeriodCycleAccumulationPercent(params, payload) {
    return axios.post(
      `${config.Performance_v1}/InsertUpdatePeriodCycleAccumulationPercent`,
      payload,
      { params }
    );
  },

  async InsertUpdatePerformancePeriodCycle(payload) {
    return axios.post(`${config.Performance_v1}/InsertUpdatePerformancePeriodCycle`, payload);
  },

  async GetAllPerformanceObjectiveHeader() {
    return axios.get(`${config.Performance_v1}/GetAllPerformanceObjectiveHeader`);
  },

  async GetReviewTemplateObjective(params) {
    return axios.get(`${config.Performance_v1}/GetReviewTemplateObjective`, { params });
  },

  async InsertUpdateDeleteReviewTemplateObjective(payload) {
    return axios.post(
      `${config.Performance_v1}/InsertUpdateDeleteReviewTemplateObjective`,
      payload
    );
  },

  async GetLatestWorkerPerformance(params) {
    return axios.get(`${config.Performance_v1}/GetLatestWorkerPerformance`, { params });
  },
};

const PerformancePotentialConfig = {
  async GetAllPfmcpotentialReviewTemplate() {
    return axios.get(`${config.PerformancePotential_v1}/GetAllPfmcpotentialReviewTemplate`);
  },

  async DownloadFinalPotentialRatingLines(params) {
    return axios.get(`${config.PerformancePotential_v1}/DownloadFinalPotentialRatingLines`, {
      params,
    });
  },

  async UploadFinalRatingLines(payload, params) {
    return axios.post(`${config.PerformancePotential_v1}/UploadFinalRatingLines`, payload, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async UpdateConfirmPotential(params, payload) {
    return axios.post(`${config.PerformancePotential_v1}/UpdateConfirmPotential`, payload, {
      params,
    });
  },
};

const ReportConfig = {
  async exportEBupotA1(params) {
    return axios.post(`${config.Reporting_v1}/exportEBupotA1`, null, { params });
  },

  async exportEBupotcoretaxSPT21Final(params) {
    return axios.post(`${config.Reporting_v1}/exportEBupotcoretaxSPT21Final`, null, { params });
  },

  async exportEBupotcoretaxSPTMassa(params) {
    return axios.post(`${config.Reporting_v1}/exportEBupotcoretaxSPTMassa`, null, {
      params,
      responseType: "blob",
    });
  },

  async exportEBupotcoretaxSPTMassaAll(params) {
    return axios.post(`${config.Reporting_v1}/exportEBupotcoretaxSPTMassaAll`, null, {
      params,
      responseType: "blob",
    });
  },

  async exportxlmSPT1721A1(params) {
    return axios.post(`${config.Reporting_v1}/exportxlmSPT1721A1`, null, { params });
  },

  async exportSPT1721A1Coretax(params) {
    return axios.post(`${config.Reporting_v1}/exportSPT1721A1Coretax`, null, {
      params,
      responseType: "blob",
    });
  },

  async exportSPT1721A1CoretaxAll(params) {
    return axios.post(`${config.Reporting_v1}/exportSPT1721A1CoretaxAll`, null, {
      params,
      responseType: "blob",
    });
  },

  async exportEBupot(params) {
    return axios.post(`${config.Reporting_v1}/exportEBupot`, null, { params });
  },

  async GeneratePayslipbyworker(params) {
    return axios.post(`${config.Reporting_v1}/GeneratePayslipbyworker`, null, {
      params,
      responseType: "blob",
    });
  },

  async ReportDefinitionGenerator(payload, params) {
    return axios.post(`${config.Reporting_v1}/ReportDefinitionGenerator`, payload, { params });
  },

  // Already used in production as a Telerik report data source
  // (attendance.jsx/AttendanceByFindim.jsx) -- reused here to feed PayrollReportViewer
  // directly for the arketipe D attendance-detail grid.
  async GetReportAttendanceByWorkerOrOrganization(payload, params) {
    return axios.post(`${config.Reporting_v1}/GetReportAttendanceByWorkerOrOrganization`, payload, {
      params,
    });
  },

  async getdataexport(params) {
    return axios.get(`${config.Reporting_v1}/getdataexport`, { params });
  },

  async getreportdatasourcecolumnname(params) {
    return axios.get(`${config.Reporting_v1}/getreportdatasourcecolumnname`, { params });
  },

  async Getdataexportdatasourcecolumn(params) {
    return axios.get(`${config.Reporting_v1}/Getdataexportdatasourcecolumn`, { params });
  },

  async Getdataexportdatasourcefield(params) {
    return axios.get(`${config.Reporting_v1}/Getdataexportdatasourcefield`, { params });
  },

  async Getdataexportdatasource() {
    return axios.get(`${config.Reporting_v1}/Getdataexportdatasource`);
  },

  async Getalluserdataexport() {
    return axios.get(`${config.Reporting_v1}/Getalluserdataexport`);
  },

  async Exportdataresult(params) {
    return axios.post(`${config.Reporting_v1}/Exportdataresult`, null, {
      params,
      responseType: "blob",
    });
  },

  async insertupdateexportdata(payload) {
    return axios.post(`${config.Reporting_v1}/insertupdateexportdata`, payload);
  },

  async deleteexportdata(params) {
    return axios.delete(`${config.Reporting_v1}/deleteexportdata`, { params });
  },

  async getdataforexport(params) {
    return axios.get(`${config.Reporting_v1}/getdataforexport`, { params });
  },

  async getAllSysReportTable() {
    return axios.get(`${config.Reporting_v1}/getAllSysReportTable`);
  },

  async LookupReportLayout(params) {
    return axios.get(`${config.Reporting_v1}/LookupReportLayout`, { params });
  },

  async GenerateFileReport(payload, params) {
    return axios.post(`reportapi${config.Reporting_v1}/GenerateFileReport`, payload, {
      params,
      responseType: "blob",
    });
  },
};

const PayrollConfig = {
  async GetAllPeriodLine(params) {
    return axios.get(`${config.payroll_v1}/GetAllPeriodLine`, { params });
  },

  async othercomponentbyperiodandtype(params) {
    return axios.get(`${config.payroll_v1}/othercomponentbyperiodandtype`, { params });
  },

  async GetAllothercomponentAsync(params) {
    return axios.get(`${config.payroll_v1}/GetAllothercomponentAsync`, { params });
  },

  async GetTemplateCSV() {
    return axios.get(`${config.payroll_v2}/GetTemplateCSV`, { responseType: "blob" });
  },

  async GetTemplatePayrollbegbalCSV() {
    return axios.get(`${config.payroll_v2}/GetTemplatePayrollbegbalCSV`, { responseType: "blob" });
  },

  async GetAllComponent() {
    return axios.get(`${config.payroll_v1}/GetAllComponent`);
  },

  async GetAllFormula() {
    return axios.get(`${config.payroll_v1}/GetAllFormula`);
  },

  async Irregularableinsert(payload) {
    return axios.post(`${config.payroll_v1}/Irregularableinsert`, payload);
  },

  async uploadData(payload, params) {
    return axios.post(`${config.payroll_v2}/uploadData`, payload, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async uploadDataPayrollbegbal(payload, params) {
    return axios.post(`${config.payroll_v2}/uploadDataPayrollbegbal`, payload, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async GetPolicyLineByEligibilityFor(params) {
    return axios.get(`${config.payroll_v1}/GetPolicyLineByEligibilityFor`, { params });
  },

  async Irregulartablebyperiodcode(params) {
    return axios.get(`${config.payroll_v1}/Irregulartablebyperiodcode`, { params });
  },

  async GetExhangeRateHeadersbytype(params) {
    return axios.get(`${config.payroll_v2}/GetExhangeRateHeadersbytype`, { params });
  },

  async GetWorkerVariableValueByProcessId(params) {
    return axios.post(`${config.payroll_v1}/GetWorkerVariableValueByProcessId`, null, { params });
  },

  async ConfirmunconfirmBankTransfer(params) {
    return axios.post(`${config.payroll_v1}/ConfirmunconfirmBankTransfer`, null, { params });
  },

  async GetWorkerVariableValueByProcessIdandpersonnelnumber(params) {
    return axios.post(
      `${config.payroll_v1}/GetWorkerVariableValueByProcessIdandpersonnelnumber`,
      null,
      { params }
    );
  },

  async getAllPayrollParameter() {
    return axios.get(`${config.payroll_v1}/getAllPayrollParameter`);
  },

  async InsertUpdatePayrollParameter(payload) {
    return axios.post(`${config.payroll_v1}/InsertUpdatePayrollParameter`, payload);
  },

  async GetAllProcessConfirmprevcurrentdate(params) {
    return axios.get(`${config.payroll_v1}/GetAllProcessConfirmprevcurrentdate`, { params });
  },

  async Calculatedworkerlist(params) {
    return axios.get(`${config.payroll_v1}/Calculatedworkerlist`, { params });
  },

  async GetAllBasicSalaryStructureLines() {
    return axios.get(`${config.payroll_v1}/GetAllBasicSalaryStructureLines`);
  },

  async Irregularablegetall() {
    return axios.get(`${config.payroll_v1}/Irregularablegetall`);
  },

  async Irregularlinetgetall(params) {
    return axios.get(`${config.payroll_v1}/Irregularlinetgetall`, { params });
  },

  async Irregularlinesbyperiodcode(params) {
    return axios.get(`${config.payroll_v1}/Irregularlinesbyperiodcode`, { params });
  },

  async Irregularlineinsert(payload) {
    return axios.post(`${config.payroll_v1}/Irregularlineinsert`, payload);
  },

  async irregularlinedelete(params) {
    return axios.post(`${config.payroll_v1}/irregularlinedelete`, null, { params });
  },

  async Irregulartabledelete(params) {
    return axios.post(`${config.payroll_v1}/Irregulartabledelete`, null, { params });
  },

  async PostWorkerFinalCalculationNextPeriod(payload) {
    return axios.post(`${config.payroll_v2}/postworkerfinalcalculationnextperiod`, payload);
  },

  async GetWorkerFinalCalculationNextPeriod(params) {
    return axios.get(`${config.payroll_v2}/getworkerfinalcalculationnextperiod`, { params });
  },

  async GetCurrentEmployeelistsTerminatebyprocessid(params) {
    return axios.get(`${config.payroll_v2}/GetCurrentEmployeelistsTerminatebyprocessid`, {
      params,
    });
  },

  async DeleteWorkerFinalCalculationNextPeriod(payload, params) {
    return axios.delete(`${config.payroll_v2}/deleteworkerfinalcalculationnextperiod`, {
      data: payload,
      params,
    });
  },
};

const PendingTransferConfig = {
  async GetPendingTransfer() {
    return axios.get(`${config.PendingTransfer_v1}/GetPendingTransfer`);
  },

  async GetPendingTransferById(params) {
    return axios.get(`${config.PendingTransfer_v1}/GetPendingTransferById`, { params });
  },

  async CreatePendingTransfer(payload) {
    return axios.post(`${config.PendingTransfer_v1}/CreatePendingTransfer`, payload);
  },

  async UpdatePendingTransfer(payload) {
    return axios.post(`${config.PendingTransfer_v1}/UpdatePendingTransfer`, payload);
  },

  async DeletePendingTransfer(params) {
    return axios.delete(`${config.PendingTransfer_v1}/DeletePendingTransfer`, { params });
  },

  async ReleasePendingTransfer(params) {
    return axios.post(`${config.PendingTransfer_v1}/ReleasePendingTransfer`, null, { params });
  },

  async ReleasePendingTransfers(payload, params) {
    return axios.post(`${config.PendingTransfer_v1}/ReleasePendingTransfers`, payload, { params });
  },

  async DeletePendingTransfers(payload) {
    return axios.post(`${config.PendingTransfer_v1}/DeletePendingTransfers`, payload);
  },
};

const RetroPayConfig = {
  async GetRetroHistory(params) {
    return axios.get(`${config.RetroPay_v1}/GetRetroHistory`, { params });
  },

  async GetRetroHistoryById(params) {
    return axios.get(`${config.RetroPay_v1}/GetRetroHistoryById`, { params });
  },

  async ExportRetroHistory(params) {
    return axios.get(`${config.RetroPay_v1}/ExportRetroHistory`, { params, responseType: "blob" });
  },

  async ExportRetroHistoryList() {
    return axios.get(`${config.RetroPay_v1}/ExportRetroHistoryList`, { responseType: "blob" });
  },
};

const SalaryChangeConfig = {
  async GetSalaryChanges(params) {
    return axios.get(`${config.SalaryChange_v1}/GetSalaryChanges`, { params });
  },

  async ExportSalaryChanges(params) {
    return axios.get(`${config.SalaryChange_v1}/ExportSalaryChanges`, {
      params,
      responseType: "blob",
    });
  },

  async GetSalaryChangeById(params) {
    return axios.get(`${config.SalaryChange_v1}/GetSalaryChangeById`, { params });
  },

  async SearchEmployee(params) {
    return axios.get(`${config.SalaryChange_v1}/SearchEmployee`, { params });
  },

  async GetCurrentAmount(params) {
    return axios.get(`${config.SalaryChange_v1}/GetCurrentAmount`, { params });
  },

  async CheckSalaryChangeLine(params) {
    return axios.get(`${config.SalaryChange_v1}/CheckSalaryChangeLine`, { params });
  },

  async SaveSalaryChange(payload) {
    return axios.post(`${config.SalaryChange_v1}/SaveSalaryChange`, payload);
  },

  async CancelSalaryChange(params) {
    return axios.post(`${config.SalaryChange_v1}/CancelSalaryChange`, null, { params });
  },

  async CancelSalaryChangeBulk(transactionids) {
    return axios.post(`${config.SalaryChange_v1}/CancelSalaryChangeBulk`, transactionids);
  },

  async DeleteSalaryChange(params) {
    return axios.delete(`${config.SalaryChange_v1}/DeleteSalaryChange`, { params });
  },

  async GetTemplateUploadSalaryChangeCSV() {
    return axios.get(`${config.SalaryChange_v1}/GetTemplateUploadSalaryChangeCSV`, {
      responseType: "blob",
    });
  },

  async CheckUploadSalaryChangeCSV(payload, params) {
    return axios.post(`${config.SalaryChange_v1}/CheckUploadSalaryChangeCSV`, payload, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async UploadSalaryChangeCSV(payload, params) {
    return axios.post(`${config.SalaryChange_v1}/UploadSalaryChangeCSV`, payload, {
      params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

const SuccessionPlanConfig = {
  async GetAllSuccessionPlanHeader(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetAllSuccessionPlanHeader`, { params });
  },

  async GetSuccessionPlanHeaderByRowId(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetSuccessionPlanHeaderByRowId`, { params });
  },

  async InsertUpdateSuccessionPlanHeader(payload) {
    return axios.post(`${config.SuccessionPlan_v1}/InsertUpdateSuccessionPlanHeader`, payload);
  },

  async DeleteSucessionPlanHeader(params) {
    return axios.delete(`${config.SuccessionPlan_v1}/DeleteSucessionPlanHeader`, { params });
  },

  async GetOrgJob(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetOrgJob`, { params });
  },

  async GetOrgJobPosition(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetOrgJobPosition`, { params });
  },

  async GetCriteria(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetCriteria`, { params });
  },

  async GetSuccessionResult(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetSuccessionResult`, { params });
  },

  async GetSuccessionResultDetail(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetSuccessionResultDetail`, { params });
  },

  async AnalyzeCriteria(payload) {
    return axios.post(`${config.SuccessionPlan_v1}/AnalyzeCriteria`, payload);
  },

  async UpdateSuccessionResult(payload) {
    return axios.post(`${config.SuccessionPlan_v1}/UpdateSuccessionResult`, payload);
  },

  async ActivateDeactive(params) {
    return axios.post(`${config.SuccessionPlan_v1}/ActivateDeactive`, null, { params });
  },

  async GetSuccessorByJob(params) {
    return axios.get(`${config.SuccessionPlan_v1}/GetSuccessorByJob`, { params });
  },
};

const TalentPoolConfig = {
  async GetAllSuccessionPlanHeader(params) {
    return axios.get(`${config.TalentPool_v1}/GetAllTalentPool`, { params });
  },

  async InsertUpdateTalentPool(payload) {
    return axios.post(`${config.TalentPool_v1}/InsertUpdateTalentPool`, payload);
  },

  async DeleteTalentPool(params) {
    return axios.delete(`${config.TalentPool_v1}/DeleteTalentPool`, { params });
  },

  async GetAllTalentPoolLineMemberByCode(params) {
    return axios.get(`${config.TalentPool_v1}/GetAllTalentPoolLineMemberByCode`, { params });
  },

  async InsertTalentPoolLineMember(payload) {
    return axios.post(`${config.TalentPool_v1}/InsertTalentPoolLineMember`, payload);
  },

  async DeleteTalentPoolLineMember(params) {
    return axios.delete(`${config.TalentPool_v1}/DeleteTalentPoolLineMember`, { params });
  },

  async GenerateIDP(payload) {
    return axios.post(`${config.TalentPool_v1}/GenerateIDP`, payload);
  },
};

const UserDatapolicyConfig = {
  async GetCoreParameter() {
    return axios.get(`${config.UserDatapolicy_v1}/GetCoreParameter`);
  },
};

const RatingConfig = {
  async GetRatingTypesLinesByRatingTypeHeader(params) {
    return axios.get(`${config.Rating_v1}/GetRatingTypesLinesByRatingTypeHeader`, {
      params,
    });
  },

  async GetAllRatingTypeLines(params) {
    return axios.get(`${config.Rating_v1}/GetAllRatingTypeLines`, {
      params,
    });
  },
};

const companyInfoConfig = {
  async GetAllSubCompanyActive() {
    return axios.get(`${config.companyInfo_v1}/GetAllSubCompanyActive`);
  },

  async GetAllSubCompany(params) {
    return axios.get(`${config.companyInfo_v1}/GetAllSubCompany`, { params });
  },

  async GetAll() {
    return axios.get(`${config.companyInfo_v1}/GetAll`);
  },

  async GetAllSubCompanyFindim(params) {
    return axios.get(`${config.companyInfo_v1}/GetAllSubCompanyFindim`, { params });
  },

  async GetCompanyPolicyByPerson(params) {
    return axios.get(`${config.companyInfo_v1}/GetCompanyPolicyByPerson`, { params });
  },
};

const DashboardConfig = {
  async GetCompanynews() {
    return axios.get(`${config.Dashboard_v1}/GetCompanynews`);
  },

  async GetEmployeeBirthdayDashboard() {
    return axios.get(`${config.Dashboard_v1}/GetEmployeeBirthdayDashboard`);
  },

  async workeremplymentsectiondashboard() {
    return axios.get(`${config.Dashboard_v1}/workeremplymentsectiondashboard`);
  },
};

const HcmReportConfig = {
  async GetNumberOfEmployeesNearingEndOfEmploymentAndProbation() {
    return axios.get(
      `${config.HcmReport_v1}/GetNumberOfEmployeesNearingEndOfEmploymentAndProbation`
    );
  },
};

const organizationConfig = {
  async GetAllOrganization() {
    return axios.get(`${config.organization_v1}/GetAllOrganization`);
  },

  async GetAllMasterSkills() {
    return axios.get(`${config.organization_v1}/GetAllMasterSkill`);
  },

  async GetAllOrgUnitCompanyHiearchies() {
    return axios.get(`${config.organization_v1}/GetAllOrgUnitCompanyHiearchies`);
  },

  async GetAllHierarchyOrgUnitHiearchiesEffectiveDate(params) {
    return axios.get(`${config.organization_v1}/GetAllHierarchyOrgUnitHiearchiesEffectiveDate`, {
      params,
    });
  },

  async GetAllOrganizationByLowestChartLevel(params) {
    return axios.get(`${config.organization_v1}/GetAllOrganizationByLowestChartLevel`, {
      params,
    });
  },

  async GetOrganizationHierarchyFromChildToParent(params) {
    return axios.get(`${config.organization_v1}/GetOrganizationHierarchyFromChildToParent`, {
      params,
    });
  },
};

const workerConfig = {
  async GetAllWorkLocation() {
    return axios.get(`${config.worker_v1}/GetAllWorkLocation`);
  },

  async GetWorkerSecondaryPosition(params) {
    return axios.get(`${config.worker_v1}/GetWorkerSecondaryPosition`, { params });
  },

  async GetApprovedWorkerSecondaryPosition(params) {
    return axios.get(`${config.worker_v1}/GetApprovedWorkerSecondaryPosition`, { params });
  },

  async InsertWorkerSecondaryPosition(payload) {
    return axios.post(`${config.worker_v1}/InsertWorkerSecondaryPosition`, payload);
  },

  async UpdateWorkerSecondaryPosition(payload) {
    return axios.put(`${config.worker_v1}/UpdateWorkerSecondaryPosition`, payload);
  },

  async DeleteWorkerSecondaryPosition(params) {
    return axios.delete(`${config.worker_v1}/DeleteWorkerSecondaryPosition`, { params });
  },

  async CancelWorkerSecondaryPosition(params) {
    return axios.post(`${config.worker_v1}/CancelWorkerSecondaryPosition`, null, { params });
  },

  async GetWorkerDetailByPerson(params) {
    return axios.get(`${config.worker_v1}/GetWorkerDetailByPerson`, { params });
  },

  async GetAllHcmContractTerms() {
    return axios.get(`${config.worker_v1}/GetAllHcmContractTerms`);
  },

  async GetAllLearningCourseByPerson(params) {
    return axios.get(`${config.worker_v1}/GetAllLearningCourseByPerson`, { params });
  },

  async GetAllWorker() {
    return axios.get(`${config.worker_v1}/GetAllWorker`);
  },

  async GetAllWorkerRelationshipByWorker(params) {
    return axios.get(`${API_V1}/Worker/GetAllWorkerRelationshipByWorker`, { params });
  },

  async InsertUpdateWorkerRelationship(payload) {
    return axios.post(`${API_V1}/Worker/InsertUpdateWorkerRelationship`, payload);
  },
};

const idpConfig = {
  async GenerateIDP(payload) {
    return axios.post(`${config.idp_v1}/GenerateIDP`, payload);
  },

  async GetAllWorkerIDP(payload) {
    return axios.post(`${config.idp_v1}/GetAllWorkerIDP`, payload);
  },

  async GetWorkerIDPCharacter(params) {
    return axios.get(`${config.idp_v1}/GetWorkerIDPCharacter`, { params });
  },

  async InsertUpdateWorkerIDPCharacter(payload) {
    return axios.post(`${config.idp_v1}/InsertUpdateWorkerIDPCharacter`, payload);
  },

  async GetWorkerIDPJobProfile(params) {
    return axios.get(`${config.idp_v1}/GetWorkerIDPJobProfile`, { params });
  },

  async DeleteJobPlan(params) {
    return axios.post(`${config.idp_v1}/DeleteJobPlan`, null, { params });
  },

  async InsertUpdateWorkerIDPJobPlanProfile(payload) {
    return axios.post(`${config.idp_v1}/InsertUpdateWorkerIDPJobPlanProfile`, payload);
  },

  async DeleteWorkerIDPJobProfile(payload) {
    return axios.delete(`${config.idp_v1}/DeleteWorkerIDPJobProfile`, {
      data: payload,
    });
  },

  async InsertUpdateWorkerIDPJobPlan(payload) {
    return axios.post(`${config.idp_v1}/InsertUpdateWorkerIDPJobPlan`, payload);
  },

  async OpenCloseIDP(payload) {
    return axios.post(`${config.idp_v1}/OpenCloseIDP`, payload);
  },

  async ExploreCareer(payload) {
    return axios.post(`${config.idp_v1}/ExploreCareer`, payload);
  },

  async ChooseCareer(payload) {
    return axios.post(`${config.idp_v1}/ChooseCareer`, payload);
  },

  async GetJobPlanRequirement(payload) {
    return axios.post(`${config.idp_v1}/GetJobPlanRequirement`, payload);
  },

  async StartMonitoring(params) {
    return axios.post(`${config.idp_v1}/StartMonitoring`, null, { params });
  },

  async GetWorkerIDPJobPlan(params) {
    return axios.get(`${config.idp_v1}/GetWorkerIDPJobPlan`, { params });
  },

  async GetCompetencyGap(params) {
    return axios.post(`${config.idp_v1}/GetCompetencyGap`, null, { params });
  },

  async EditJobPlan(payload) {
    return axios.post(`${config.idp_v1}/EditJobPlan`, payload);
  },

  async GetCompetencyGapJobs(payload) {
    return axios.post(`${config.idp_v1}/GetCompetencyGapJobs`, payload);
  },

  async UpdateWorkerQualifications(params) {
    return axios.post(`${config.idp_v1}/UpdateWorkerQualifications`, null, { params });
  },
};

const performanceBoxAnalysisConfig = {
  async GetTalentReviewByRowId(params) {
    return axios.get(`${config.PerformanceBoxAnalysis_v1}/GetTalentReviewByRowId`, { params });
  },

  async SendInvitationEmailTalentReview(params) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/SendInvitationEmailTalentReview`, null, {
      params,
    });
  },

  async GetWorkerRisk(params) {
    return axios.get(`${config.PerformanceBoxAnalysis_v1}/GetWorkerRisk`, {
      params,
    });
  },

  async UpdateWorkerCompetency(params) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/UpdateWorkerCompetency`, null, {
      params,
    });
  },

  async GetBoxAnalysisHeader(payload) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/GetBoxAnalysisHeader`, payload);
  },

  async GetBoxConfiguration() {
    return axios.get(`${config.PerformanceBoxAnalysis_v1}/GetBoxConfiguration`);
  },

  async InsertUpdateBoxConfiguration(payload) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/InsertUpdateBoxConfiguration`, payload);
  },

  async UpdateFinalScore(payload) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/UpdateFinalScore`, payload);
  },

  async UpdateAdditionalScore(payload) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/UpdateAdditionalScore`, payload);
  },

  async ConfirmWorkerBoxAnalysis(params, payload) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/ConfirmWorkerBoxAnalysis`, payload, {
      params,
    });
  },

  async UnconfirmWorkerBoxAnalysis(params, payload) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/UnconfirmWorkerBoxAnalysis`, payload, {
      params,
    });
  },

  async ClearBoxAnalysis(params, payload) {
    return axios.delete(`${config.PerformanceBoxAnalysis_v1}/ClearBoxAnalysis`, {
      data: payload, // Gunakan 'data' untuk mengirim body
      params, // Gunakan 'params' untuk query string
    });
  },

  async GetLatestWorkerBoxAnalysis(payload) {
    return axios.post(`${config.PerformanceBoxAnalysis_v1}/GetLatestWorkerBoxAnalysis`, payload);
  },
};
const WorkflowConfig = {
  async saveAsNewWorkflowLine(payload) {
    return axios.post(`${config.Workflow_v1}/saveAsNewWorkflowLine`, payload);
  },

  async saveWorkflowLine(payload) {
    return axios.post(`${config.Workflow_v1}/saveWorkflowLine`, payload);
  },

  async executeWFActionByRecords(payload) {
    return axios.post(`${config.Workflow_v1}/executeWFActionByRecords`, payload);
  },

  async getUpdateControlsWF(params) {
    return axios.get(`${config.Workflow_v1}/getUpdateControlsWF`, { params });
  },

  async executeWFAction(payload) {
    return axios.post(`${config.Workflow_v1}/executeWFAction`, payload);
  },

  async SubmitWFActionBulk(payload) {
    return axios.post(`${config.Workflow_v1}/SubmitWFActionBulk`, payload);
  },

  async validateapprovaldocument(params) {
    return axios.get(`${config.Workflow_v1}/validateapprovaldocument`, { params });
  },

  async GetWorkflowbywftypeassigntomeAsync() {
    return axios.get(`${config.Workflow_v1}/GetWorkflowbywftypeassigntomeAsync`);
  },

  async getWorkflowTableById(params) {
    return axios.get(`${config.Workflow_v1}/getWorkflowTableById`, { params });
  },

  async getWorkflowTableByWFType(params) {
    return axios.get(`${config.Workflow_v1}/getWorkflowTableByWFType`, { params });
  },

  async ChangeActiveVersionWF(params) {
    return axios.put(`${config.Workflow_v1}/ChangeActiveVersionWF`, null, { params });
  },

  async InactiveAllVersionWFByType(params) {
    return axios.put(`${config.Workflow_v1}/InactiveAllVersionWFByType`, null, { params });
  },

  async insertWorkflowTable(payload) {
    return axios.post(`${config.Workflow_v1}/insertWorkflowTable`, payload);
  },

  async ConfigureAutoApproveWF(payload) {
    return axios.post(`${config.Workflow_v1}/ConfigureAutoApproveWF`, payload);
  },

  async deleteWorkflowTable(params) {
    return axios.delete(`${config.Workflow_v1}/deleteWorkflowTable`, { params });
  },

  async GetWorkflowbywftypeassigntomedetailAsync(params) {
    return axios.get(`${config.Workflow_v1}/GetWorkflowbywftypeassigntomedetailAsync`, {
      params,
    });
  },
};

const CompetencyConfig = {
  async GetAllCompetencies() {
    return axios.get(`${config.Competency_v1}/GetAllCompetencies`);
  },

  async GetHcmCompetenciesByTypeId(params) {
    return axios.get(`${config.Competency_v1}/GetHcmCompetenciesByTypeId`, { params });
  },

  async GetAllPersonCompetenciesByPerson(params) {
    return axios.get(`${config.Competency_v1}/GetAllPersonCompetenciesByPerson`, { params });
  },
};

const PositionConfig = {
  async getPositionSkillByPositionId(params) {
    return axios.get(`${config.Position_v1}/getPositionSkillByPositionId`, { params });
  },

  async InsertUpdatePositionSkill(payload) {
    return axios.post(`${config.Position_v1}/InsertUpdatePositionSkill`, payload);
  },

  async deletePositionSkill(params) {
    return axios.delete(`${config.Position_v1}/deletePositionSkill`, { params });
  },

  async GetAllPositionCompetenciesByPositionId(params) {
    return axios.get(`${config.Position_v1}/GetAllPositionCompetenciesByPositionId`, { params });
  },

  async InsertUpdatePositionCompetencies(payload) {
    return axios.post(`${config.Position_v1}/InsertUpdatePositionCompetencies`, payload);
  },

  async DeletePositionCompetencies(params) {
    return axios.delete(`${config.Position_v1}/DeletePositionCompetencies`, { params });
  },

  async GetAllPositionCertificatesByPositionId(params) {
    return axios.get(`${config.Position_v1}/GetAllPositionCertificatesByPositionId`, { params });
  },

  async InsertUpdatePositionCertificates(payload) {
    return axios.post(`${config.Position_v1}/InsertUpdatePositionCertificates`, payload);
  },

  async DeletePositionCertificates(params) {
    return axios.delete(`${config.Position_v1}/DeletePositionCertificates`, { params });
  },

  async GetPositionLearningByPositionId(params) {
    return axios.get(`${config.Position_v1}/GetPositionLearningByPositionId`, { params });
  },

  async InsertUpdatePositionLearning(payload) {
    return axios.post(`${config.Position_v1}/InsertUpdatePositionLearning`, payload);
  },

  async DeletePositionLearning(params) {
    return axios.delete(`${config.Position_v1}/DeletePositionLearning`, { params });
  },

  async DeletePositionCompetenciesByType(params) {
    return axios.delete(`${config.Position_v1}/DeletePositionCompetenciesByType`, { params });
  },

  async GetAllPositionEducationByPositionId(params) {
    return axios.get(`${config.Position_v1}/GetAllPositionEducationByPositionId`, { params });
  },

  async InsertUpdatePositionEducation(payload) {
    return axios.post(`${config.Position_v1}/InsertUpdatePositionEducation`, payload);
  },

  async DeletePositionEducation(params) {
    return axios.delete(`${config.Position_v1}/DeletePositionEducation`, { params });
  },

  async getemptyposition(params) {
    return axios.get(`${config.Position_v1}/getemptyposition`, { params });
  },

  async getPositionFindimByPositionId(params) {
    return axios.get(`${API_V1}/position/getPositionFindimByPositionId`, { params });
  },

  async getPositionById(params) {
    return axios.get(`${API_V1}/position/getPositionById`, { params });
  },

  async getAllPosition() {
    return axios.get(`${API_V1}/position/getAllPosition`);
  },

  async GetAllReportToPositionRelationship(params) {
    return axios.get(`${API_V1}/position/GetAllReportToPositionRelationship`, { params });
  },

  async getPositionViewById(params) {
    return axios.get(`${API_V1}/position/getPositionViewById`, { params });
  },

  async getAllPositionWorkerAssignment(params) {
    return axios.get(`${config.Position_v1}/getAllPositionWorkerAssignment`, { params });
  },

  async getAllPositionByFilter(params) {
    return axios.get(`${API_V1}/position/getAllPositionByFilter`, { params });
  },
};

const jobConfig = {
  async GetAllOrgJob() {
    return axios.get(`${config.job_v1}/GetAllOrgJob`);
  },

  async GetAllCertificate() {
    return axios.get(`${config.job_v1}/GetAllCertificate`);
  },

  async InsertUpdateCertificate(payload) {
    return axios.post(`${config.job_v1}/InsertUpdateCertificate`, payload);
  },

  async DeleteCertificate(params) {
    return axios.delete(`${config.job_v1}/DeleteCertificate`, { params });
  },
};

const LearningHcmCourseConfig = {
  async GetAllLearningCourse() {
    return axios.get(`${config.LearningHcmCourse_v1}/GetAllLearningCourse`);
  },

  async GetAllHcmLearningCourseEventsrage(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetAllHcmLearningCourseEventsrage`, {
      params,
    });
  },

  async GetAllLearningPreferredCompetencies(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetAllLearningPreferredCompetencies`, {
      params,
    });
  },

  async GetAllLearningPreferredCertificates(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetAllLearningPreferredCertificates`, {
      params,
    });
  },

  async GetHcmLearningCourseEventsByID(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetHcmLearningCourseEventsByID`, {
      params,
    });
  },

  async InsertUpdateHcmLearningCourseEvents(payload) {
    return axios.post(
      `${config.LearningHcmCourse_v1}/InsertUpdateHcmLearningCourseEvents`,
      payload
    );
  },

  async GetLearningCourseEventRequest(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetLearningCourseEventRequest`, {
      params,
    });
  },

  async GetLearningCourseEventRequestByRecId(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetLearningCourseEventRequestByRecId`, {
      params,
    });
  },

  async InsertUpdateLearningCourseEventRequest(payload) {
    return axios.post(
      `${config.LearningHcmCourse_v1}/InsertUpdateLearningCourseEventRequest`,
      payload
    );
  },

  async DeleteLearningCourseEventRequest(params) {
    return axios.delete(`${config.LearningHcmCourse_v1}/DeleteLearningCourseEventRequest`, {
      params,
    });
  },

  async GenerateECertificate(params) {
    return axios.post(`${config.LearningHcmCourse_v1}/GenerateECertificate`, null, { params });
  },

  async GetLearningEventsByPerson(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetLearningEventsByPerson`, {
      params,
    });
  },

  async GetParticipantListFromIDP(params) {
    return axios.get(`${config.LearningHcmCourse_v1}/GetParticipantListFromIDP`, {
      params,
    });
  },

  async GetGeneralParticipantLearningCourseEvents() {
    return axios.get(`${config.LearningHcmCourse_v1}/GetGeneralParticipantLearningCourseEvents `);
  },
};

const EducationConfig = {
  async getAllEducationLevel() {
    return axios.get(`${config.Education_v1}/getAllEducationLevel`);
  },

  async getAllEducationMajor() {
    return axios.get(`${config.Education_v1}/getAllEducationMajor`);
  },

  async getAllEducationInstitution() {
    return axios.get(`${config.Education_v1}/getAllEducationInstitution`);
  },

  async InsertUpdateEducationInstitution(params) {
    return axios.post(`${config.Education_v1}/InsertUpdateEducationInstitution`, params);
  },

  async InsertUpdateEducationMajor(params) {
    return axios.post(`${config.Education_v1}/InsertUpdateEducationMajor`, params);
  },
};

const SysemailConfig = {
  async getAllEmailtemplate() {
    return axios.get(`${config.Sysemail_v1}/getAllEmailtemplate`);
  },

  async getAllDocumentTemplate() {
    return axios.get(`${config.Sysemail_v1}/getAllDocumentTemplate`);
  },

  async GetDocumentTemplatePlaceholders(params) {
    return axios.get(`${config.Sysemail_v1}/GetDocumentTemplatePlaceholders`, { params });
  },

  async InsertDocumentTable(payload) {
    return axios.post(`${config.Sysemail_v1}/InsertDocumentTable`, payload);
  },

  async UpdateDocumentTable(payload) {
    return axios.put(`${config.Sysemail_v1}/UpdateDocumentTable`, payload);
  },

  async DeleteDocumentTable(payload) {
    return axios.delete(`${config.Sysemail_v1}/DeleteDocumentTable`, {
      data: payload, // Gunakan 'data' untuk mengirim body
      params: null, // Gunakan 'params' untuk query string
    });
  },
};

const overtimeConfig = {
  async GetOvertimeAssignedToMe(params) {
    return axios.get(`${config.overtime_v1}/GetOvertimeAssignedToMe`, { params });
  },

  async deleteOvertimeRequest(params) {
    return axios.delete(`${config.overtime_v1}/deleteOvertimeRequest`, { params });
  },

  async ApproveOvertimeRequest(payload) {
    return axios.post(`${config.overtime_v1}/ApproveOvertimeRequest`, payload);
  },

  async RejectOvertimeRequest(payload) {
    return axios.post(`${config.overtime_v1}/RejectOvertimeRequest`, payload);
  },

  async getAllOvetimeType() {
    return axios.get(`${config.overtime_v1}/getAllOvetimeType`);
  },

  async InsertUpdateOvertimeRequest(payload) {
    return axios.post(`${config.overtime_v1}/InsertUpdateOvertimeRequest`, payload);
  },

  async CancelOvertimeRequest(params) {
    return axios.post(`${config.overtime_v1}/CancelOvertimeRequest`, null, { params });
  },

  async CancelOvertimeRequestInBulk(params, payload) {
    return axios.post(`${config.overtime_v1}/CancelOvertimeRequestInBulk`, payload, { params });
  },

  async getAllOvetimeScaleByProfile(params) {
    return axios.get(`${config.overtime_v1}/getAllOvetimeScaleByProfile`, { params });
  },

  async InsertUpdateOvertimeScale(payload) {
    return axios.post(`${config.overtime_v1}/InsertUpdateOvertimeScale`, payload);
  },

  async deleteOvertimeScale(params) {
    return axios.delete(`${config.overtime_v1}/deleteOvertimeScale`, { params });
  },

  async SummarizeOvertime(params) {
    return axios.post(`${config.overtime_v1}/SummarizeOvertime`, null, { params });
  },

  async TransferSummarizeOvertimetoLeaveBalance(params, paylaod) {
    return axios.post(`${config.overtime_v1}/TransferSummarizeOvertimetoLeaveBalance`, paylaod, {
      params,
    });
  },

  async GetSummarizeOT(payload) {
    return axios.post(`${config.overtime_v1}/GetSummarizeOT`, payload);
  },

  async GetCalculationOTSummaryByRowId(params) {
    return axios.post(`${config.overtime_v1}/GetCalculationOTSummaryByRowId`, null, { params });
  },

  async DeleteOvertimeSummary(payload) {
    return axios.delete(`${config.overtime_v1}/DeleteOvertimeSummary`, {
      data: payload, // Gunakan 'data' untuk mengirim body
      params: null, // Gunakan 'params' untuk query string
    });
  },

  async RollbackTransferOvertimeSummary(payload) {
    return axios.delete(`${config.overtime_v1}/RollbackTransferOvertimeSummary`, {
      data: payload, // Gunakan 'data' untuk mengirim body
      params: null, // Gunakan 'params' untuk query string
    });
  },

  async GetOTGroup(params) {
    return axios.get(`${config.overtime_v1}/GetOTGroup`, { params });
  },

  async GetOTGroupByReqNumber(params) {
    return axios.get(`${config.overtime_v1}/GetOTGroupByReqNumber`, { params });
  },

  async GetOTGroupTodoListDetails(params) {
    return axios.get(`${config.overtime_v1}/GetOTGroupTodoListDetails`, { params });
  },

  async PreviewValidateOvertimeGroup(payload) {
    return axios.post(`${config.overtime_v1}/PreviewValidateOvertimeGroup`, payload);
  },

  async ValidateOvertimeGroupLines(payload) {
    return axios.post(`${config.overtime_v1}/ValidateOvertimeGroupLines`, payload);
  },

  async InsertOvertimeGroup(payload) {
    return axios.post(`${config.overtime_v1}/InsertOvertimeGroup`, payload);
  },

  async AddOTGroupClassification(paylaod) {
    return axios.post(`${config.overtime_v1}/AddOTGroupClassification`, paylaod);
  },

  async UpdateOTGroupDetail(payload) {
    return axios.post(`${config.overtime_v1}/UpdateOTGroupDetail`, payload);
  },

  async DeleteOTGroup(params) {
    return axios.delete(`${config.overtime_v1}/DeleteOTGroup`, { params });
  },

  async DeleteLinesOTGroup(payload) {
    return axios.delete(`${config.overtime_v1}/DeleteLinesOTGroup`, { data: payload });
  },

  // Bulk Overtime Request
  async GetBulkHeadersByDateRange(params) {
    return axios.get(`${config.overtime_v1}/GetBulkHeadersByDateRange`, { params });
  },

  async GetBulkRequestDetailByNumber(otReqNumber) {
    return axios.get(`${config.overtime_v1}/GetBulkRequestDetail/${otReqNumber}`);
  },

  async ValidateOvertimeBulkRequest(payload) {
    return axios.post(`${config.overtime_v1}/ValidateOvertimeBulkRequest`, payload);
  },

  async InsertBulkHeaderAndLines(payload) {
    return axios.post(`${config.overtime_v1}/InsertBulkHeaderAndLines`, payload);
  },

  async InsertUpdateBulkLines(payload) {
    return axios.post(`${config.overtime_v1}/InsertUpdateBulkLines`, payload);
  },

  async DeleteBulkRequestDetail(otReqNumber) {
    return axios.delete(`${config.overtime_v1}/DeleteBulkRequestDetail/${otReqNumber}`);
  },

  async DeleteBulkRequestLine(rowid) {
    return axios.delete(`${config.overtime_v1}/DeleteBulkRequestLine/${rowid}`);
  },

  async DeleteBulkLines(payload) {
    return axios.delete(`${config.overtime_v1}/DeleteBulkLines`, payload);
  },

  async UpdateBulkStatusLine(rowid, status) {
    return axios.post(`${config.overtime_v1}/UpdateBulkStatusLine`, null, {
      params: { rowid, status },
    });
  },

  async CancelOTBulkRequest(payload, params) {
    return axios.post(`${config.overtime_v1}/CancelOTBulkRequest`, payload, { params });
  },
};

const ReasonCodeConfig = {
  async getAllReasonCode() {
    return axios.get(`${config.ReasonCode_v1}/getAllReasonCode`);
  },
};

const KankeiReportConfig = {
  async candataattendanceshowinreport(params, payload) {
    return axios.post(`${config.KankeiReport_v1}/candataattendanceshowinreport`, payload, {
      params,
    });
  },

  async ExportattendanceReportDetailVertical(params, payload) {
    return axios.post(`${config.KankeiReport_v1}/ExportattendanceReportDetailVertical`, payload, {
      params,
      responseType: "blob",
    });
  },
};

const AttendanceConfig = {
  async Generateschedulebygroup(params, payload) {
    return axios.post(`${config.Attendance_v2}/Generateschedulebygroup`, payload, {
      params,
    });
  },

  async validateschedulegroup(params) {
    return axios.post(`${config.Attendance_v2}/validateschedulegroup`, null, {
      params,
    });
  },

  async getAttendancefromintegrationwithparameter() {
    return axios.get(`${config.Attendance_v2}/getAttendancefromintegrationwithparameter`);
  },

  async getscheduleworkerlist(params) {
    return axios.get(`${config.Attendance_v2}/getscheduleworkerlist`, { params });
  },

  async postAttendancefromintegrationwithparameter(params) {
    return axios.post(`${config.Attendance_v2}/postAttendancefromintegrationwithparameter`, null, {
      params,
    });
  },

  async getAttendanceMachineAll() {
    return axios.get(`${config.Attendance_v2}/getattendacemachineall`);
  },

  async InsertUpdateAttendanceMachine(payload) {
    return axios.post(`${config.Attendance_v2}/attendacemachineinsertupdate`, payload);
  },

  async deleteAttendanceMachine(params) {
    return axios.delete(`${config.Attendance_v2}/DeleteattendacemachineByrowidAsync`, { params });
  },

  async GetScheduleByOrgAndDateRange(payload, params) {
    return axios.post(`${config.Attendance_v1}/GetScheduleByOrgAndDateRange`, payload, { params });
  },

  async GetAbsenceGroup() {
    return axios.get(`${config.Attendance_v1}/GetAbsenceGroup`);
  },

  async GetScheduleByWorkerListAndDateRange(payload, params) {
    return axios.post(`${config.Attendance_v1}/GetScheduleByWorkerListAndDateRange`, payload, {
      params,
    });
  },

  async GetScheduleScheduleGroupAndDateRange(payload, params) {
    return axios.post(`${config.Attendance_v1}/GetScheduleScheduleGroupAndDateRange`, payload, {
      params,
    });
  },

  async InsertUpdateScheduleRoosterTrans(payload, params) {
    return axios.post(`${config.Attendance_v1}/InsertUpdateScheduleRoosterTrans`, payload, {
      params,
    });
  },

  async GetScheduleWorker(payload) {
    return axios.post(`${config.Attendance_v1}/GetScheduleWorker`, payload);
  },

  async deleteScheduleEmployee(params, payload) {
    return axios.delete(`${config.Attendance_v1}/deleteScheduleEmployee`, {
      params,
      data: payload,
    });
  },

  async Getwoowtimeabsencebyworkeranddate(params) {
    return axios.get(`${config.Attendance_v1}/Getwoowtimeabsencebyworkeranddate`, { params });
  },

  async GenerateWoowtimeAbsence(payload, params) {
    return axios.post(`${config.Attendance_v1}/GenerateWoowtimeAbsence`, payload, {
      params,
    });
  },

  async PreviewAndValidateAbsenceTransRooster(payload) {
    return axios.post(`${config.Attendance_v1}/PreviewAndValidateAbsenceTransRooster`, payload);
  },

  async PreviewAndValidateDeleteBulkSchedule(payload) {
    return axios.delete(`${config.Attendance_v1}/PreviewAndValidateDeleteBulkSchedule`, {
      params: null,
      data: payload,
    });
  },

  async GenerateAllMedicalEmpl() {
    return axios.get(`${config.Attendance_v1}/GenerateAllMedicalEmpl`);
  },
};

const BenefitConfig = {
  // Reimbursement Transaction Header
  async GetAllBenReimbursementTransHeader(params) {
    return axios.get(`${config.benefit_v1}/GetAllBenReimbursementTransHeader`, { params });
  },

  async GetBenReimbursementTransHeaderByID(params) {
    return axios.get(`${config.benefit_v1}/GetBenReimbursementTransHeaderByID`, { params });
  },

  async InsertUpdateBenReimbursementTransHeader(payload) {
    return axios.post(`${config.benefit_v1}/InsertUpdateBenReimbursementTransHeader`, payload);
  },

  async DeleteBenReimbursementTransHeader(params) {
    return axios.delete(`${config.benefit_v1}/deleteBenReimbursementTransHeader`, { params });
  },

  async ApproveBenefitReimbursement(payload, params) {
    return axios.post(`${config.benefit_v1}/ApproveBenefitReimbursement`, payload, { params });
  },

  async RejectBenefitReimbursement(payload, params) {
    return axios.post(`${config.benefit_v1}/RejectBenefitReimbursement`, payload, { params });
  },

  async CancelBenefitReimbursement(params) {
    return axios.post(`${config.benefit_v1}/CancelBenefitReimbursement`, null, { params });
  },

  // Reimbursement Transaction Lines
  async GetAllBenReimbursementTransLinesByHeader(params) {
    return axios.get(`${config.benefit_v1}/GetAllBenReimbursementTransLinesByHeader`, { params });
  },

  async GetReimbursementCurrentBalance(params) {
    return axios.get(`${config.benefit_v1}/GetReimbursementCurrentBalance`, { params });
  },

  async InsertUpdateBenReimbursementTransLines(payload) {
    return axios.post(`${config.benefit_v1}/InsertUpdateBenReimbursementTransLines`, payload);
  },

  async DeleteBenReimbursementTransLines(params) {
    return axios.delete(`${config.benefit_v1}/deleteBenReimbursementTransLines`, { params });
  },

  // Reimbursement Balance
  async GetAllEligibleBenefitReimbursementBalanceByWorker(params) {
    return axios.get(`${config.benefit_v1}/GetAllEligibleBenefitReimbursementBalanceByWorker`, {
      params,
    });
  },

  async UpdateBenefitReimbursementBalance(payload) {
    return axios.post(`${config.benefit_v1}/UpdateBenefitReimbursementBalance`, payload);
  },

  async GetAllBenefitReimbursementBalanceByPeriod(params) {
    return axios.get(`${config.benefit_v1}/GetAllBenefitReimbursementBalanceByPeriod`, { params });
  },

  async InsertUpdateBenefitReimbursementBalance(payload) {
    return axios.post(`${config.benefit_v1}/InsertUpdateBenefitReimbursementBalance`, payload);
  },

  async DeleteBenefitReimbursementBalance(params) {
    return axios.delete(`${config.benefit_v1}/deleteBenefitReimbursementBalance`, { params });
  },

  async ExtendBenefitReimbursementBalanceByPeriod(params) {
    return axios.get(`${config.benefit_v1}/ExtendBenefitReimbursementBalanceByPeriod`, { params });
  },

  async ExtendBenefitReimbursementBalanceByWorker(params) {
    return axios.get(`${config.benefit_v1}/ExtendBenefitReimbursementBalanceByWorker`, { params });
  },

  async RegenerateBenefitReimbursementBalanceByReimbursementType(params) {
    return axios.get(
      `${config.benefit_v1}/RegenerateBenefitReimbursementBalanceByReimbursementType`,
      { params }
    );
  },

  async RegenerateBenefitReimbursementBalanceByWorker(params) {
    return axios.get(`${config.benefit_v1}/RegenerateBenefitReimbursementBalanceByWorker`, {
      params,
    });
  },

  async GenerateReimbursementAllEmpl(params) {
    return axios.get(`${config.benefit_v1}/GenerateReimbursementAllEmpl`, { params });
  },

  // Benefit Type Manager
  async GetAllBenefitTypeManager(params) {
    return axios.get(`${config.benefit_v1}/GetAllBenefitTypeManager`, { params });
  },

  async InsertUpdateBenefitTypeManager(payload) {
    return axios.post(`${config.benefit_v1}/InsertUpdateBenefitTypeManager`, payload);
  },

  async DeleteBenefitType(params) {
    return axios.delete(`${config.benefit_v1}/deleteBenefitType`, { params });
  },

  // Benefit Category
  async GetAllBenefitCategory() {
    return axios.get(`${config.benefit_v1}/GetAllBenefitCategory`);
  },
};

const TimeManagementConfig = {
  async getAllTmAbsenceStatus() {
    return axios.get(`${config.TimeManagement_v1}/getAllTmAbsenceStatus`);
  },

  async GetAlltmabsencesetupbybreaktime() {
    return axios.get(`${config.TimeManagement_v1}/GetAlltmabsencesetupbybreaktime`);
  },

  async InsertUpdatetmabsencesetupbybreaktime(payload) {
    return axios.post(`${config.TimeManagement_v1}/InsertUpdatetmabsencesetupbybreaktime`, payload);
  },

  async deletetmabsencesetupbybreaktime(params) {
    return axios.delete(`${config.TimeManagement_v1}/deletetmabsencesetupbybreaktime`, { params });
  },

  async GetItmabsencesetupbybreaktimeManagerebyRowid(params) {
    return axios.get(`${config.TimeManagement_v1}/GetItmabsencesetupbybreaktimeManagerebyRowid`, {
      params,
    });
  },

  async GetAlltmbreaktime() {
    return axios.get(`${config.TimeManagement_v1}/GetAlltmbreaktime`);
  },

  async InsertUpdatetmbreaktime(payload) {
    return axios.post(`${config.TimeManagement_v1}/InsertUpdatetmbreaktime`, payload);
  },

  async deletetmbreaktime(params) {
    return axios.delete(`${config.TimeManagement_v1}/deletetmbreaktime`, { params });
  },

  async getAlltmschedulegroup() {
    return axios.get(`${config.TimeManagement_v1}/getAlltmschedulegroup`);
  },

  async getAllTmDayType() {
    return axios.get(`${config.TimeManagement_v1}/getAllTmDayType`);
  },

  async getAllAbsenceParameter() {
    return axios.get(`${config.TimeManagement_v1}/getAllAbsenceParameter`);
  },

  async GetScheduleExchange(params) {
    return axios.get(`${config.TimeManagement_v1}/GetScheduleExchange`, { params });
  },

  async GetScheduleExchangeByRecId(params) {
    return axios.get(`${config.TimeManagement_v1}/GetScheduleExchangeByRecId`, { params });
  },

  async GetExistingSchedule(payload, params) {
    return axios.post(`${config.TimeManagement_v1}/GetExistingSchedule`, payload, { params });
  },

  async PreviewAndValidateScheduleExchange(payload) {
    return axios.post(`${config.TimeManagement_v1}/PreviewAndValidateScheduleExchange`, payload);
  },

  async InsertUpdateScheduleExchange(payload) {
    return axios.post(`${config.TimeManagement_v1}/InsertUpdateScheduleExchange`, payload);
  },

  async InsertUpdateAbsenceParameter(payload) {
    return axios.post(`${config.TimeManagement_v1}/InsertUpdateAbsenceParameter`, payload);
  },

  async DeleteScheduleExchange(payload) {
    return axios.delete(`${config.TimeManagement_v1}/DeleteScheduleExchange`, {
      data: payload,
      params: null,
    });
  },
};

const policyConfig = {
  async getPolicyByPolicyType(params) {
    return axios.get(`${config.policy_v1}/getPolicyByPolicyType`, { params });
  },
  async getPolicyFields(params) {
    return axios.get(`${config.policy_v1}/getPolicyFields`, { params });
  },
  async getPolicyByPolicyModuleRecId(params) {
    return axios.get(`${config.policy_v1}/getPolicyByPolicyModuleRecId`, { params });
  },

  async getPolicyLineByPolicyRecId(policyrecid) {
    return axios.get(`${config.policy_v1}/getPolicyLineByPolicyRecId?policyrecid=${policyrecid}`);
  },

  async getAllPolicyModules() {
    return axios.get(`${config.policy_v1}/getAllPolicyModules`);
  },

  async insertPolicyLine(payload) {
    return axios.post(`${config.policy_v1}/insertPolicyLine`, payload);
  },

  async updatePolicyLine(payload) {
    return axios.put(`${config.policy_v1}/updatePolicyLine`, payload);
  },

  async insertUpdatePolicy(payload) {
    return axios.post(`${config.policy_v1}/insertUpdatePolicy`, payload);
  },

  async updateStatusPolicy(params) {
    return axios.post(`${config.policy_v1}/UpdateStatusPolicy`, {}, { params });
  },

  async deletePolicy(params) {
    return axios.delete(`${config.policy_v1}/deletePolicy`, { params });
  },

  async deletePolicyLine(params) {
    return axios.delete(`${config.policy_v1}/deletePolicyLine`, { params });
  },
};

const UserConfig = {
  async GetUser(params) {
    return axios.get(`${config.User_v1}`, { params });
  },

  async GetAllUserGroup() {
    return axios.get(`${config.User_v1}/GetAllUserGroup`);
  },
  async GetAuditTrail() {
    return axios.get(`${config.User_v1}/GetAuditTrail`);
  },

  async GetAuditTable() {
    return axios.get(`${config.User_v1}/GetAuditTable`);
  },

  async GetSetAuditTable() {
    return axios.get(`${config.User_v1}/GetSetAuditTable`);
  },

  async UpdateAuditTable(payload) {
    return axios.post(`${config.User_v1}/UpdateAuditTable`, payload);
  },

  async getTreeObjectReference(params) {
    return axios.get(`${config.User_v1}/getTreeObjectReference`, { params });
  },
};

const CompensationLevelConfig = {
  async getAllLevel() {
    return axios.get(`${config.CompensationLevel_v1}/getAllLevel`);
  },
};

const NumberSequenceConfig = {
  async GetById(params) {
    return axios.get(`${config.NumberSequence_v1}/GetById`, { params });
  },
};

const WorkerActionConfig = {
  async RejectWorkerAction(params) {
    return axios.post(`${config.WorkerAction_v1}/RejectWorkerAction`, null, { params });
  },

  async addHireWorkerAction(payload) {
    return axios.post(`${config.WorkerAction_v1}/addHireWorkerAction`, payload);
  },

  async updateHireWorkerAction(payload) {
    return axios.put(`${config.WorkerAction_v1}/updateHireWorkerAction`, payload);
  },

  async addTransferWorkerAction(payload) {
    return axios.post(`${config.WorkerAction_v1}/addTransferWorkerAction`, payload);
  },

  async updateTransferWorkerAction(payload) {
    return axios.put(`${config.WorkerAction_v1}/updateTransferWorkerAction`, payload);
  },

  async addRehireWorkerAction(payload) {
    return axios.post(`${config.WorkerAction_v1}/addRehireWorkerAction`, payload);
  },

  async updateRehireWorkerAction(payload) {
    return axios.put(`${config.WorkerAction_v1}/updateRehireWorkerAction`, payload);
  },

  async rehireWorkerAction(params) {
    return axios.post(`${config.WorkerAction_v1}/rehireWorkerAction`, null, { params });
  },

  async addTerminationWorkerAction(payload) {
    return axios.post(`${config.WorkerAction_v1}/addTerminationWorkerAction`, payload);
  },

  async updateTerminationWorkerAction(payload) {
    return axios.put(`${config.WorkerAction_v1}/updateTerminationWorkerAction`, payload);
  },

  async GetPersonalInfoByWorkerAction(payload) {
    return axios.post(`${config.WorkerAction_v1}/GetPersonalInfoByWorkerAction`, payload);
  },

  async getWorkerHireActionByRecId(params) {
    return axios.get(`${config.WorkerAction_v1}/getWorkerHireActionByRecId`, { params });
  },

  async getWorkerActionByPrevActionNumber(params) {
    return axios.get(`${config.WorkerAction_v1}/getWorkerActionByPrevActionNumber`, { params });
  },

  async getWorkerTerminateActionByRecId(params) {
    return axios.get(`${config.WorkerAction_v1}/getWorkerTerminateActionByRecId`, { params });
  },

  async getWorkerTransferActionByRecId(params) {
    return axios.get(`${config.WorkerAction_v1}/getWorkerTransferActionByRecId`, { params });
  },

  async GetPersonalInfoByApplicant(payload) {
    return axios.post(`${config.WorkerAction_v1}/GetPersonalInfoByApplicant`, payload);
  },

  async deleteWorkerAction(params) {
    return axios.delete(`${config.WorkerAction_v1}/deleteWorkerAction`, { params });
  },

  async CancelledWorkerAction(params) {
    return axios.post(`${config.WorkerAction_v1}/CancelledWorkerAction`, null, { params });
  },

  async hireWorkerAction(params) {
    return axios.post(`${config.WorkerAction_v1}/hireWorkerAction`, null, { params });
  },

  async transferWorkerAction(params) {
    return axios.post(`${config.WorkerAction_v1}/transferWorkerAction`, null, { params });
  },

  async terminateWorkerAction(params) {
    return axios.post(`${config.WorkerAction_v1}/terminateWorkerAction`, null, { params });
  },

  async GetWorkerActionMass(params) {
    return axios.post(`${config.WorkerAction_v1}/GetWorkerActionMass`, null, { params });
  },

  async GetWorkerActionMassHeaderDetailByRecId(params) {
    return axios.post(`${config.WorkerAction_v1}/GetWorkerActionMassHeaderDetailByRecId`, null, {
      params,
    });
  },

  async GetLookupWorkerTerminationMass() {
    return axios.post(`${config.WorkerAction_v1}/GetLookupWorkerTerminationMass`);
  },

  async PreviewAndValidateWorkerActionMass(payload) {
    return axios.post(`${config.WorkerAction_v1}/PreviewAndValidateWorkerActionMass`, payload);
  },

  async RevalidateWorkerActionMass(payload) {
    return axios.post(`${config.WorkerAction_v1}/RevalidateWorkerActionMass`, payload);
  },

  async AddWorkerInWorkerActionMass(payload) {
    return axios.post(`${config.WorkerAction_v1}/AddWorkerInWorkerActionMass`, payload);
  },

  async InsertUpdateWorkerActionMass(payload) {
    return axios.post(`${config.WorkerAction_v1}/InsertUpdateWorkerActionMass`, payload);
  },

  async DeleteWorkerActionMass(params) {
    return axios.post(`${config.WorkerAction_v1}/DeleteWorkerActionMass`, null, { params });
  },

  async DeleteWorkerActionMassDetail(payload) {
    return axios.post(`${config.WorkerAction_v1}/DeleteWorkerActionMassDetail`, payload);
  },

  async GetLookupActiveWorkerInWorkerAction() {
    return axios.post(`${config.WorkerAction_v1}/GetLookupActiveWorkerInWorkerAction`);
  },

  async GetLookupExpiredWorkerInWorkerAction() {
    return axios.post(`${config.WorkerAction_v1}/GetLookupExpiredWorkerInWorkerAction`);
  },
};

const WorkerBPJSTaxInfoConfig = {
  async GetactivePytaxlocationAsync() {
    return axios.get(`${config.WorkerBPJSTaxInfo_v1}/GetactivePytaxlocationAsync`);
  },

  async getAllTaxLocation() {
    return axios.get(`${config.WorkerBPJSTaxInfo_v1}/getAllTaxLocation`);
  },

  async getmaintaxlocation(params) {
    return axios.get(`${config.WorkerBPJSTaxInfo_v1}/getmaintaxlocation`, { params });
  },

  async updateWorkerTaxInformation(payload) {
    return axios.put(`${config.WorkerBPJSTaxInfo_v1}/updateWorkerTaxInformation`, { payload });
  },
};

const TimesheetConfig = {
  async GetAllTimesheetProject() {
    return axios.get(`${config.Timesheet_v1}/GetAllTimesheetProject`);
  },

  async GetAllTimesheetProjectbymemberAsync(params) {
    return axios.get(`${config.Timesheet_v1}/GetAllTimesheetProjectbymemberAsync`, { params });
  },

  async GetAllByDateAAsync(params) {
    return axios.get(`${config.Timesheet_v1}/GetAllByDateAAsync`, { params });
  },
};

const PersonnelActionTypeConfig = {
  async getAllPersonnelActionType() {
    return axios.get(`${config.PersonnelActionType_v1}/getAllPersonnelActionType`);
  },

  async getPersonnelActionTypeById(payload) {
    return axios.get(`${config.PersonnelActionType_v1}/getPersonnelActionTypeById`, {
      params: payload,
    });
  },
};

const WorkListConfig = {
  async GetSetupWorkListTemplate() {
    return axios.post(`${config.WorkList_v1}/GetSetupWorkListTemplate`);
  },

  async GetWorklistTemplateWorker(payload) {
    return axios.post(`${config.WorkList_v1}/GetWorklistTemplateWorker`, payload);
  },

  async GetSummaryWorklist(params) {
    return axios.post(`${config.WorkList_v1}/GetSummaryWorklist`, null, { params });
  },

  async GetUnfinishedWorkTaskList(params) {
    return axios.post(`${config.WorkList_v1}/GetUnfinishedWorkTaskList`, null, { params });
  },

  async GetMyTaskList(params) {
    return axios.get(`${config.WorkList_v1}/GetMyTaskList`, { params });
  },

  async GetAllWorkList(params) {
    return axios.post(`${config.WorkList_v1}/GetAllWorkList`, null, { params });
  },

  async GetWorkListCategory() {
    return axios.post(`${config.WorkList_v1}/GetWorkListCategory`);
  },

  async GetSetupWorkList() {
    return axios.post(`${config.WorkList_v1}/GetSetupWorkList`);
  },

  async InsertUpdateSetupWorkListTemplate(payload) {
    return axios.post(`${config.WorkList_v1}/InsertUpdateSetupWorkListTemplate`, payload);
  },

  async DeleteSetupWorkListTemplate(params) {
    return axios.delete(`${config.WorkList_v1}/DeleteSetupWorkListTemplate`, { params });
  },

  async GetWorkTaskListTemplate(params) {
    return axios.post(`${config.WorkList_v1}/GetWorkTaskListTemplate`, {}, { params });
  },

  async GetSetupWorkListByCategory(params) {
    return axios.get(`${config.WorkList_v1}/GetSetupWorkListByCategory`, { params });
  },

  async InsertUpdateWorkTaskListTemplate(payload) {
    return axios.post(`${config.WorkList_v1}/InsertUpdateWorkTaskListTemplate`, payload);
  },

  async UpdateUserWorkList(params) {
    return axios.post(`${config.WorkList_v1}/UpdateUserWorkList`, {}, { params });
  },

  async GetWorkListByUserId(params) {
    return axios.post(`${config.WorkList_v1}/GetWorkListByUserId`, {}, { params });
  },

  async GetUserWorkTaskList(params) {
    return axios.post(`${config.WorkList_v1}/GetUserWorkTaskList`, {}, { params });
  },

  async ExtendDateCompleted(params) {
    return axios.post(`${config.WorkList_v1}/ExtendDateCompleted`, {}, { params });
  },

  async GetWorkTaskList(params) {
    return axios.post(`${config.WorkList_v1}/GetWorkTaskList`, {}, { params });
  },

  async InsertUpdateSetupWorkList(payload) {
    return axios.post(`${config.WorkList_v1}/InsertUpdateSetupWorkList`, payload);
  },

  async DeleteSetupWorkList(params) {
    return axios.delete(`${config.WorkList_v1}/DeleteSetupWorkList`, { params });
  },

  async InsertUpdateWorkTaskList(payload) {
    return axios.post(`${config.WorkList_v1}/InsertUpdateWorkTaskList`, payload);
  },
};

const BankConfig = {
  async Bank() {
    return axios.get(`${config.Bank_v1}`);
  },
};

const ApplicantConfig = {
  async GetApplicationOfferingDetailLatestByApplicationId(params) {
    return axios.get(`${config.Applicant_v1}/GetApplicationOfferingDetailLatestByApplicationId`, {
      params,
    });
  },

  async GetApplicantByApplicantId(params) {
    return axios.post(`${config.Applicant_v1}/GetApplicantByApplicantId`, null, {
      params,
    });
  },

  async GetApplicantCvByApplicantId(params) {
    return axios.post(`${config.Applicant_v1}/GetApplicantCvByApplicantId`, null, {
      params,
    });
  },

  async GetAllApplicant(params) {
    if (!params) {
      return axios.get(`${config.Applicant_v1}/GetAllApplicant`);
    }

    const qs = buildQueryFromParams(params);
    const url = `${config.Applicant_v1}/GetAllApplicant${qs ? `?${qs}` : ""}`;
    return axios.get(url);
  },

  async GetAllApplicantbyname(params) {
    if (!params) {
      return axios.get(`${config.Applicant_v1}/GetAllApplicantbyname`);
    }

    const qs = buildQueryFromParams(params);
    const url = `${config.Applicant_v1}/GetAllApplicantbyname${qs ? `?${qs}` : ""}`;
    return axios.get(url);
  },
};

const RecruitmentSetupConfig = {
  async GetAllRecruitmentParameter() {
    return axios.get(`${config.RecruitmentSetup_v1}/GetAllRecruitmentParameter`);
  },
};

const WorkerRequestConfig = {
  async GetAllWorkerRequestHeader() {
    return axios.get(`${config.WorkerRequest_v1}/GetAllWorkerRequestHeader`);
  },

  async InsertUpdateWorkerRequestHeaderLines(payload) {
    return axios.post(`${config.WorkerRequest_v1}/InsertUpdateWorkerRequestHeaderLines`, payload);
  },
};

const ManPowerPlanningConfig = {
  async GetAllWorkerRequisitionPeriod() {
    return axios.get(`${config.ManPowerPlanning_v1}/GetAllWorkerRequisitionPeriod`);
  },
};

const DataChangesConfig = {
  async GetAllDataChanges() {
    return axios.get(`${config.DataChanges_v1}/GetAllDataChanges`);
  },
};

const QuestionnaireConfig = {
  async GetQuestionnaire() {
    return axios.get(`${config.Questionnaire_v1}/GetQuestionnaire`);
  },

  async GetQuestionnaireQuestionAnswer(params) {
    return axios.get(`${config.Questionnaire_v1}/GetQuestionnaireQuestionAnswer`, { params });
  },

  async GetQuestionnaireResponse(params) {
    return axios.get(`${config.Questionnaire_v1}/GetQuestionnaireResponse`, { params });
  },

  async UpdateBulkQuestionnaireAnswer(params, payload) {
    return axios.post(`${config.Questionnaire_v1}/UpdateBulkQuestionnaireAnswer`, payload, {
      params,
    });
  },
};

const LearningMasterConfig = {
  async GetAllLearningInstructure() {
    return axios.get(`${config.LearningMaster_v1}/GetAllLearningInstructure`);
  },
};

const DocumentConfig = {
  async DeleteDocument(params) {
    return axios.delete(`${config.Document_v1}/DeleteDocument`, { params });
  },

  async InsertUpdateDocumentBulk(payload, params, requestConfig = {}) {
    return axios.post(`${config.Document_v1}/InsertUpdateDocumentBulk`, payload, {
      params,
      ...requestConfig,
    });
  },

  async GetAllDocumentByRefTableAndRefKey(params) {
    return axios.get(`${config.Document_v1}/GetAllDocumentByRefTableAndRefKey`, { params });
  },

  async GetAllDocumentByRefTableAndRefRecid(params) {
    return axios.get(`${config.Document_v1}/GetAllDocumentByRefTableAndRefRecid`, { params });
  },
};

const LoanConfig = {
  async GetAllloantype() {
    return axios.get(`${config.Loan_v1}/GetAllloantype`);
  },

  async InsertUpdateLoanType(payload) {
    return axios.post(`${config.Loan_v1}/InsertUpdateLoanType`, payload);
  },

  async DeleteLoanType(params) {
    return axios.delete(`${config.Loan_v1}/DeleteLoanType`, { params });
  },

  async GetAllLoanRequest(params) {
    return axios.get(`${config.Loan_v1}/GetAllLoanRequest`, { params });
  },

  async GetLoanByRecIdAsync(params) {
    return axios.get(`${config.Loan_v1}/GetLoanByRecIdAsync`, { params });
  },

  async CalculateLoanRequest(payload) {
    return axios.post(`${config.Loan_v1}/CalculateLoanRequest`, payload);
  },

  async InsertUpdateLoanRequest(payload) {
    return axios.post(`${config.Loan_v1}/InsertUpdateLoanRequest`, payload);
  },

  async ConfirmLoan(params) {
    return axios.post(`${config.Loan_v1}/ConfirmLoan`, null, { params });
  },

  async PostponeLoan(params) {
    return axios.post(`${config.Loan_v1}/PostponeLoan`, null, { params });
  },

  async SettlementLoan(params) {
    return axios.post(`${config.Loan_v1}/SettlementLoan`, null, { params });
  },

  async DeleteLoanrequest(params) {
    return axios.delete(`${config.Loan_v1}/DeleteLoanrequest`, { params });
  },
};

const AlertModelConfig = {
  async GetAllDataSourceAlertModel() {
    return axios.get(`${config.AlertModel_v1}/GetAllDataSourceAlertModel`);
  },
};

const NotificationConfig = {
  async GetUserDeviceListbyworkerid(params) {
    return axios.post(`${config.Notification_v1}/GetUserDeviceListbyworkerid`, null, { params });
  },

  async setauthorization(params) {
    return axios.post(`${config.Notification_v1}/setauthorization`, null, { params });
  },

  async SendToSpecificUser(params) {
    return axios.post(`${config.Notification_v1}/SendToSpecificUser`, null, { params });
  },

  async GetAllUserdeviceList() {
    return axios.get(`${config.Notification_v1}/GetAllUserdeviceList`);
  },
};

const GlobalMasterTableConfig = {
  async GetWorkforceParameter() {
    return axios.get(`${config.GlobalMasterTable_v1}/GetWorkforceParameter`);
  },

  async UpdateWorkforceParameter(payload) {
    return axios.post(`${config.GlobalMasterTable_v1}/UpdateWorkforceParameter`, payload);
  },
};

const LoginServiceConfig = {
  /**
   * @deprecated Obsolete. Do not use this method in new code.
   * Background is fetched from userinfo OIDC, stored in localStorage with key `tenantImage`
   */
  async GetsystemsettingBydomain(params) {
    return axiosLogin.get(`${config.Login_service}/GetsystemsettingBydomain`, { params });
  },
};

const TrvExpConfig = {
  async ValidateOutstandingTransaction(params) {
    return axios.post(`${config.TrvExp_v1}/ValidateOutstandingTransaction`, null, { params });
  },
};

const PayrollReportConfigConfig = {
  async GetAllConfig(params) {
    return axios.get(`${config.PayrollReportConfig_v1}/GetAllConfig`, { params });
  },

  async GetConfig(params) {
    return axios.get(`${config.PayrollReportConfig_v1}/GetConfig`, { params });
  },

  async SaveConfig(payload) {
    return axios.post(`${config.PayrollReportConfig_v1}/SaveConfig`, payload);
  },

  async DuplicateConfig(payload) {
    return axios.post(`${config.PayrollReportConfig_v1}/DuplicateConfig`, payload);
  },

  async DeleteConfig(params) {
    return axios.delete(`${config.PayrollReportConfig_v1}/DeleteConfig`, { params });
  },
};

const TemplateGeneratorConfig = {
  async GetTemplateAbsenceScheduleCSV(params) {
    return axios.get(`${config.TemplateGenerator_v1}/GetTemplateAbsenceScheduleCSV`, {
      params,
      responseType: "blob",
    });
  },
};

const BlastEmailConfig = {
  async getTemplates() {
    return axios.get(`${config.BlastEmail_v1}/templates`);
  },

  async getTemplateDetail(rowId) {
    return axios.get(`${config.BlastEmail_v1}/templates/${rowId}`);
  },

  async createTemplate(payload) {
    return axios.post(`${config.BlastEmail_v1}/templates`, payload);
  },

  async updateTemplate(rowId, payload) {
    return axios.put(`${config.BlastEmail_v1}/templates/${rowId}`, payload);
  },

  async deleteTemplate(rowId) {
    return axios.delete(`${config.BlastEmail_v1}/templates/${rowId}`);
  },

  async getPlaceholders() {
    return axios.get(`${config.BlastEmail_v1}/placeholders`);
  },

  async send(payload) {
    return axios.post(`${config.BlastEmail_v1}/send`, payload);
  },

  async saveDraft(payload) {
    return axios.post(`${config.BlastEmail_v1}/save-draft`, payload);
  },

  async updateDraft(rowId, payload) {
    return axios.put(`${config.BlastEmail_v1}/update-draft/${rowId}`, payload);
  },

  async getDrafts(params) {
    return axios.get(`${config.BlastEmail_v1}/get-drafts`, { params });
  },

  async getDraftDetail(rowId) {
    return axios.get(`${config.BlastEmail_v1}/get-draft/${rowId}`);
  },

  async deleteDraft(rowId) {
    return axios.delete(`${config.BlastEmail_v1}/delete-draft/${rowId}`);
  },

  async submitDraft(rowId) {
    return axios.post(`${config.BlastEmail_v1}/submit-draft/${rowId}`);
  },

  async getHistory(params) {
    return axios.get(`${config.BlastEmail_v1}/history`, { params });
  },

  async getHistoryLogs(burstId) {
    return axios.get(`${config.BlastEmail_v1}/history/${burstId}/logs`);
  },
};

const PreferenceConfig = {
  async GetAll() {
    return axios.get(`${config.Preference_v1}/GetAll`);
  },

  async GetByKey(params) {
    return axios.get(`${config.Preference_v1}/GetByKey`, { params });
  },

  async GetByKeys(payload) {
    return axios.post(`${config.Preference_v1}/GetByKeys`, payload);
  },

  async InsertUpdate(payload) {
    return axios.post(`${config.Preference_v1}/InsertUpdate`, payload);
  },
};

const respository = {
  person: personConfig,
  systemconfig: apisystemconfig,
  hangfire: hangfireConfig,
  SystemSetting: SystemSettingConfig,
  lookupdata: lookupdataConfig,
  GlobalMasterlines: GlobalMasterlinesConfig,
  Persons: PersonsConfig,
  Performance: performanceConfig,
  PerformancePotential: PerformancePotentialConfig,
  Reporting: ReportConfig,
  payroll: PayrollConfig,
  PendingTransfer: PendingTransferConfig,
  SuccessionPlan: SuccessionPlanConfig,
  TalentPool: TalentPoolConfig,
  UserDatapolicy: UserDatapolicyConfig,
  Rating: RatingConfig,
  companyInfo: companyInfoConfig,
  Dashboard: DashboardConfig,
  HcmReport: HcmReportConfig,
  organization: organizationConfig,
  worker: workerConfig,
  idp: idpConfig,
  PerformanceBoxAnalysis: performanceBoxAnalysisConfig,
  Workflow: WorkflowConfig,
  Competency: CompetencyConfig,
  Position: PositionConfig,
  job: jobConfig,
  LearningHcmCourse: LearningHcmCourseConfig,
  Education: EducationConfig,
  Sysemail: SysemailConfig,
  overtime: overtimeConfig,
  ReasonCode: ReasonCodeConfig,
  KankeiReport: KankeiReportConfig,
  Attendance: AttendanceConfig,
  benefit: BenefitConfig,
  TimeManagement: TimeManagementConfig,
  policy: policyConfig,
  User: UserConfig,
  CompensationLevel: CompensationLevelConfig,
  NumberSequence: NumberSequenceConfig,
  WorkerAction: WorkerActionConfig,
  WorkerBPJSTaxInfo: WorkerBPJSTaxInfoConfig,
  Timesheet: TimesheetConfig,
  PersonnelActionType: PersonnelActionTypeConfig,
  WorkList: WorkListConfig,
  Bank: BankConfig,
  Applicant: ApplicantConfig,
  RecruitmentSetup: RecruitmentSetupConfig,
  WorkerRequest: WorkerRequestConfig,
  ManPowerPlanning: ManPowerPlanningConfig,
  DataChanges: DataChangesConfig,
  Questionnaire: QuestionnaireConfig,
  LearningMaster: LearningMasterConfig,
  Document: DocumentConfig,
  Loan: LoanConfig,
  AlertModel: AlertModelConfig,
  Notification: NotificationConfig,
  GlobalMasterTable: GlobalMasterTableConfig,
  LoginService: LoginServiceConfig,
  TrvExp: TrvExpConfig,
  PayrollReportConfig: PayrollReportConfigConfig,
  TemplateGenerator: TemplateGeneratorConfig,
  BlastEmail: BlastEmailConfig,
  Preference: PreferenceConfig,
};

export default respository;
